import { isEmpty } from 'lodash';

import { ContractListSearchState } from 'pricing/pages/contractList/ContractList.state';
import { buildContractsWithTotalQuantity } from 'pricing/utilities/contract/buildContractsWithTotalQuantity/buildContractsWithTotalQuantity';
import { Contract, PaginationContractList } from 'pricing/types';
import { apiContract } from 'utilities/http/api/pricing/apiContract';

export const getContracts: (
  props: ContractListSearchState,
) => Promise<{ pagination: PaginationContractList; contracts: Contract[] }> = async (
  props,
) => {
  const { search, filters, sort, pagination } = props;

  if (isEmpty(search) && isEmpty(filters) && isEmpty(sort)) {
    const respContractList = await apiContract.getContractsList({ pagination });

    if (!respContractList.isOk) {
      throw Error(`Couldn't load any contract.`);
    }

    return {
      contracts: buildContractsWithTotalQuantity(respContractList.json.contracts.data),
      pagination: {
        currentPage: respContractList.json.contracts.currentPage,
        totalContracts: respContractList.json.contracts.total,
        pageSize: pagination.pageSize,
      },
    };
  } else {
    const respContractList = await apiContract.getContractsList({
      search,
      filters,
      sort,
      pagination,
    });

    if (!respContractList.isOk) {
      throw true;
    }

    return {
      contracts: buildContractsWithTotalQuantity(respContractList.json.contracts.data),
      pagination: {
        currentPage: respContractList.json.contracts.currentPage,
        totalContracts: respContractList.json.contracts.total,
        pageSize: pagination.pageSize,
      },
    };
  }
};
